import { render, staticRenderFns } from "./switch.vue?vue&type=template&id=6fac1198&scoped=true&"
import script from "./switch.js?vue&type=script&lang=js&"
export * from "./switch.js?vue&type=script&lang=js&"
import style0 from "./switch.css?vue&type=style&index=0&id=6fac1198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fac1198",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
